/**
 * Slick.jsをお呼びする
 */
export default class CallSlick {

  constructor(options) {
    this.options = options;
    this.$slick = $('.js-Slick');
    this.slickOptions = {
      default: {
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        centerMode: false,
        infinite: true,
        variableWidth: true,
        dots: false,
        mobileFirst: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: 0,
        swipe: false,
        responsive: [
          {
            breakpoint: 600,
              settings: 'unslick',
          },
        ]
      }
    };
    this.init();
  }

  init() {
    if (this.$slick[0]) {
      this.$slick.each((idx, el) => {
        let $this = $(el);
        let myOptions = ($this.data('slick-options')) ? this.slickOptions[$this.data('slick-options')] : this.slickOptions.default;
        let slick = new this.setSlick($this, myOptions);
      });
    }
  }

  setSlick($this, options) {
    $this.slick(options);
  }

}



// WEBPACK FOOTER //
// ./js/_module/_callSlick.js